export default __webpack_public_path__ + "static/media/uploader-caresens-2.9ff495e7.png";